"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Linkedin = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("path", { d: "M7.342 19.765h-3.83V9.142h3.83v10.623ZM5.36 7.195c-1.17 0-1.952-.78-1.952-1.821s.78-1.821 2.08-1.821c1.17 0 1.952.78 1.952 1.82 0 1.042-.78 1.822-2.08 1.822ZM21 19.765h-3.706v-5.806c0-1.606-.988-1.976-1.358-1.976-.37 0-1.606.247-1.606 1.976v5.806h-3.829V9.142h3.83v1.483c.492-.865 1.48-1.483 3.333-1.483 1.853 0 3.336 1.483 3.336 4.817v5.806Z" })
  );
};
export default Linkedin;
